import { render } from "./HomeSectionFive.vue?vue&type=template&id=1563a58d&scoped=true"
import script from "./HomeSectionFive.vue?vue&type=script&lang=js"
export * from "./HomeSectionFive.vue?vue&type=script&lang=js"

import "./HomeSectionFive.vue?vue&type=style&index=0&id=1563a58d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1563a58d"

export default script